<footer class="footer" >
    <div class="container">
        <div class="row">
            <div class="col-12 p-0">
               CrediPal 2024  <mat-icon>copyright</mat-icon> Derechos Reservados
            </div>
        </div>
    </div>
</footer>